import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/Piano/editor/pianoeditor.tsx",
    () => import("./pianoeditor"),
);
